import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
} from "@mui/material";
import { Field } from "react-final-form";
import React, { useState } from "react";
import Box from "@mui/material/Box";

export const UiSelectInput = (props) => {
  const {
    label,
    value,
    name,
    type,
    children,
    error,
    placeholder,
    multiline,
    maxRows,
    minRows,
    onInput,
    onChange,
    readonly,
    helperText,
  } = props;

  const [selValue, setSelValue] = useState(props.defVal);

  const handleChange = (e) => {
    setSelValue(e.target.value);
  };

  return (
    <>
      <Box sx={{ minWidth: 120 }}>
        <Field name={name}>
          {({ input, meta }) => (
            <FormControl
              sx={{ mb: 2 }}
              variant="outlined"
              fullWidth
              error={meta.touched && Boolean(meta.error)}
            >
              <InputLabel>{label}</InputLabel>
              <Select
                {...input}
                {...props}
                label={label}
                className="df-input-field"
              >
                {children}
              </Select>
              {meta.touched && meta.error && (
                <FormHelperText className="component-error-text">
                  {meta.error}
                </FormHelperText>
              )}
            </FormControl>
          )}
        </Field>
      </Box>
    </>
  );
};
